module.exports = __webpack_public_path__ + "img/exchange-score-btn.8095249f.png";